export const mentalHealthWork = [
  {
    organisation: "Youth Corps Singapore",
    role: "Peer Support Leader (Publicity Team), Project Re:ground",
    duration: "Nov 2024 - Dec 2025",
    jobscope: [
      {
        description:
          "Spread awareness about Project Re:ground and peer supporting on Project Re:ground's Instagram page (<a className='text-green dark:text-green-dark underline underline-offset-2' href='https://www.instagram.com/ycs.projectreground/' target='_blank' rel='noopener noreferrer'>@ycs.projectreground</a>)",
      },
      {
        description:
          "Designed various publicity collaterals for Project Re:ground's Instagram account and various events",
      },
      {
        description:
          "Oversaw a team of 6 Community Peer Supporters in contributing to publicity efforts alongside another Peer Support Leader",
      },
      {
        description:
          "Managed Instagram account, including responding to direct messages, posting stories during Re:ground @ Dungeon sessions or other events",
      },
    ],
  },
  {
    organisation: "mindline.sg Youth Fellowship 2024",
    role: "mindline.sg Youth Fellow",
    duration: "Apr 2024 - Nov 2024",
    jobscope: [
      {
        description:
          "Co-created Building Empowerment and Awareness with mindline.sg (B.E.A.M.) with like-minded peers, a project related to mindline.sg and let’s talk, aiming to create an opportunity for anyone to reflect and strengthen their self-identity, by focusing on core values, traits and strengths",
      },
      {
        description:
          "Designed a poster for the B.E.A.M. Booth, held as part of the Mental Health Film Festival Singapore 2024",
      },
      {
        description:
          "Gleaned insights from advocates in youth mental health during engaging learning sessions",
      },
      {
        description:
          "Part of a panel dialogue during Graduation Day, where I shared about youth mental health efforts, my own advocacy efforts, as well as my thoughts on the tech x mental health space alongside panellists SPS Eric Chua, AVOXTATE Founder Angelina Eng and moderator Amolika Thapliyal",
      },
      {
        description:
          "Through the fellowship, also helped out with other mindline.sg-related projects - for example, contributed as a human rater to <a className='text-green dark:text-green-dark underline underline-offset-2' href='https://arxiv.org/abs/2411.18429' target='_blank' rel='noopener noreferrer'>A Multi-Agent Dual Dialogue System to Support Mental Health Care Providers</a>",
      },
    ],
  },
  {
    organisation: "Youth Corps Singapore",
    role: "re:CEIVE Initiative (Dungeon Guardian), Project Re:ground",
    duration: "Oct 2023 - Oct 2024",
    jobscope: [
      {
        description:
          "Stepped up during Dungeon duty as Dungeon Guardian, to help improve the Project Re:ground experience for both peer supporters and participants",
      },
      {
        description: "Oversee Re:ground @ Dungeon operations",
      },
      {
        description:
          "Managed peer supporter and participant experiences through conducting debriefs and ensuring that participants are well-engaged",
      },
    ],
  },
  {
    organisation: "Youth Corps Singapore",
    role: "Peer Support Leader (Project Re:ground Ambassador), Project Re:ground",
    duration: "Sep 2023 - Oct 2024",
    jobscope: [
      {
        description:
          "In charge of spreading more awareness about Project Re:ground and peer supporting, and rallying other peer supporters to take ownership over Themed Nights (i.e., special themed sessions replacing regular nights where people can engage in different self-care activities such as crocheting, sound therapy etc)",
      },
      {
        description: "Contributed to publicity efforts on Instagram",
      },
      {
        description:
          "Creation of infographics and posters introducing Peer Support Leaders and the re:CEIVE Initiative",
      },
      {
        description: "Planning of Themed Nights",
      },
    ],
  },
  {
    organisation: "Youth Corps Singapore",
    role: "Community Peer Supporter, Project Re:ground",
    duration: "Jan 2022 - Dec 2025",
    jobscope: [
      {
        description:
          "Equipped with knowledge to provide effective support to youth upon identifying signs of distress",
      },
      {
        description:
          "Certified by HPB's Peer Support for the Youth Level 1 Training Programme",
      },
      {
        description:
          "Served as a Peer Supporter at Re:ground @ Dungeon, a safe space located at The Red Box",
      },
      {
        description:
          "Featured on Youth Corps Singapore's Instagram page <a className='text-green dark:text-green-dark underline underline-offset-2' href='https://www.instagram.com/youthcorpssg/reel/DAdOlmozyQ7/?hl=en' target='_blank' rel='noopener noreferrer'>here</a>!",
      },
    ],
  },
  {
    organisation: "Kura Kura",
    role: "Software Developer",
    duration: "Jan 2022 - Jul 2023",
    jobscope: [
      {
        description:
          "Developed frontend screens for the mobile application using React Native based on Figma mockups",
      },
      {
        description:
          "Developed a new login web screen for a dashboard component using React and Tailwind CSS for teachers to track their students’ mental wellbeing on a periodic basis",
      },
      {
        description:
          "Worked on backend calls to retrieve the data for the dashboard from an AWS EC2 server",
      },
      {
        description:
          "Set up a database for a 2-player game using Firebase’s Cloud Firestore",
      },
    ],
  },
  {
    organisation: "Kura Kura",
    role: "R&D Lead",
    duration: "Jul 2021 - Jan 2022",
    jobscope: [
      {
        description:
          "Developed a Telegram bot using Python where users could send their feedback and bugs for beta testing",
      },
      {
        description:
          "Conceptualised games that served as preventive measures to boost mental wellness for users on the application with tenets of positive psychology",
      },
    ],
  },
  {
    organisation: "Kura Kura",
    role: "Content Lead",
    duration: "Nov 2020 - Jul 2021",
    jobscope: [
      {
        description:
          "Researched and designed social media content for LinkedIn, Medium, Instagram on a weekly basis to improve user engagement and outreach",
      },
      {
        description:
          "Conducted customer outreach calls and generated leads for the company over 3 months, with one lead being the current psychology advisor, Eddie Chua",
      },
    ],
  },
  {
    organisation: "Youth Corps Singapore",
    role: "Outreach Team Member and Facilitator, Mental Health Cluster Ideathon 2021",
    duration: "Sep 2020 - Jul 2021",
    jobscope: [
      {
        description:
          "Organised training workshops, empowering participants to better care for themselves and others",
      },
      {
        description:
          "Served as a facilitator for a group of participants pitching their ideas",
      },
      {
        description: "Gained exposure to mental health professionals",
      },
      {
        description: "Learned from diverse perspectives of participants",
      },
    ],
  },
  {
    organisation: "@kelliepandasg",
    role: "Founder",
    duration: "Jun 2020 - Present",
    jobscope: [
      {
        description:
          "Initiated an Instagram page (<a className='text-green dark:text-green-dark underline underline-offset-2' href='https://www.instagram.com/kelliepandasg' target='_blank' rel='noopener noreferrer'>@kelliepandasg</a>) to inspire and spark conversations on pressing social issues during the COVID-19 period, transitioning from sharing thoughts on my personal account",
      },
      {
        description:
          "Share resources and personal reflections related to topics on mental health, sexual assault, toxic relationships, and more",
      },
      {
        description:
          "Conduct thorough research on various social topics to provide accurate and relevant information",
      },
      {
        description:
          "Design graphics using tools like Canva and Keynote to complement content and attract followers",
      },
      {
        description:
          "Create and schedule monthly (approximately) social media posts, ensuring engagement with followers",
      },
      {
        description:
          "Monitor and analyse social media metrics to refine content strategies and improve reach and impact",
      },
      {
        description:
          "Engage with followers by using polls, question boxes, and responding to comments and messages",
      },
    ],
  },
];
